var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "88E963B9-AD5C-41BA-A71A-AE4111DA780A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7,0 C7.27614237,-5.07265313e-17 7.5,0.223857625 7.5,0.5 L7.5,5 L12,5 C12.2761424,5 12.5,5.22385763 12.5,5.5 L12.5,7 C12.5,7.27614237 12.2761424,7.5 12,7.5 L7.5,7.5 L7.5,12 C7.5,12.2761424 7.27614237,12.5 7,12.5 L5.5,12.5 C5.22385763,12.5 5,12.2761424 5,12 L5,7.5 L0.5,7.5 C0.223857625,7.5 3.38176876e-17,7.27614237 0,7 L0,5.5 C-3.38176876e-17,5.22385763 0.223857625,5 0.5,5 L5,5 L5,0.5 C5,0.223857625 5.22385763,5.07265313e-17 5.5,0 L7,0 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "8-honest-conversations",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.4.2-UCAP-AdvisorCenter-HonestConversations-NewScores",
    transform: "translate(-514.000000, -818.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(260.000000, 153.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cards",
    transform: "translate(24.000000, 122.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(0.000000, 334.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clarence",
    transform: "translate(224.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 1,
    transform: "translate(0.000000, 136.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.-Buttons/Tertiary/Icon/Normal-Copy-2.-Buttons/Tertiary/Icon/Normal",
    transform: "translate(0.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "btn"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDBC-Icon-5.-Icons/General/plus"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(4.166667, 4.166667)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "ic_plus",
    fill: "#8A8888",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Color-1.-Colors/Blue",
    mask: "url(#mask-2)",
    fill: "#0047B9"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.166667, -4.166667)",
    id: "color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20,
    height: 20
  })))))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlus);
export default __webpack_public_path__ + "static/media/ic_plus.b207de94b9df787e93d3d17f5251085d.svg";
export { ForwardRef as ReactComponent };